<template>
  <div class="seatsio tickets section">
    <h2 v-if="title"
        class="title">{{ $t('tickets.comprarEntradas') }}</h2>
    <div class="container-seatsio">
      <div id="container-seatsio-widget"
           class="container" />
      <div v-if="event.authorization_file_url || event.access_policy"
           class="mT20">
        <div v-if="event.authorization_file_url"
             cols="12">
          <a :href="event.authorization_file_url"
             :title="event.authorization_file_url"
             :style="`color: ${iframe ? iframe.font_color : ''}`"
             target="_blank">
            <p :style="`color: ${iframe ? iframe.font_color : ''}`"
               class="help-text m0">
              {{ $t('tickets.descargarAutorizacionParaMenores') }}
            </p>
          </a>
        </div>
        <div v-if="event.access_policy"
             cols="12">
          <text-truncate :color="iframe ? iframe.font_color : ''">
            <p :style="`color: ${iframe ? iframe.font_color : ''}`">
              {{ event.access_policy }}
            </p>
          </text-truncate>
        </div>
      </div>
      <div class="container-actions">
        <div class="container-actions-items">
          <div class="mT20 mB20">
            <fieldset v-if="!!event.promoter_newsletter_option"
              id="purchase-newsletter-group"
              class="mT10 w100 form-group">
              <div class="custom-control custom-checkbox">
                <input id="purchase-newsletter"
                        v-model="promoter_newsletter"
                        type="checkbox"
                        name="purchase-newsletter"
                        class="custom-control-input">
                <label for="purchase-newsletter"
                        class="custom-control-label"
                        :style="`color: ${event.iframe ? event.iframe.aux_font_color || event.iframe.font_color : ''}`">
                  {{ $t('tickets.newsletter', {promoter_newsletter_text: event.promoter_newsletter_text}) }}
                </label>
              </div>
            </fieldset>
            <fieldset v-if="!!event.promoter_terms_option"
                      id="purchase-terms-group"
                      class="mT10 w100 form-group">
              <div class="custom-control custom-checkbox">
                <input id="purchase-terms"
                        v-model="promoter_terms"
                        type="checkbox"
                        name="purchase-terms"
                        class="custom-control-input">
                <label for="purchase-terms"
                        class="custom-control-label"
                        :style="`color: ${event.iframe ? event.iframe.aux_font_color || event.iframe.font_color : ''}`"
                        v-html="$t('tickets.promoter_terms', {promoter_terms_text: event.promoter_terms_text})" />
              </div>
            </fieldset>
          </div>
          <div class="tAc mT20 mB20">
            <button type="button"
                    class="btn transparent m10"
                    @click="clearSelection()"> {{ $t('seatsio.limpiar') }}</button>
            <button type="button"
                    :disabled="(!promoter_terms && !!event.promoter_terms_option) || !showButton"
                    class="btn opacity m10"
                    @click="manage()"> {{ $t('seatsio.comprar') }}</button>
          </div>
        </div>
      </div>
    </div>
    <nominatives-seatsio v-if="openSeatsioNominatives" />
    <how-many-seats v-if="openHowManySeats"
                    :max-selected-objects="$store.state.seatsio.config.max_selected_objects"
                    @setHowManySeats="howManySeats"
                    @closeHowManySeats="openHowManySeats = false" />
    <loader v-show="loading"
            class="load-more-loader"
            :middle="true" />
    <adviseSeats 
      v-if="showAdviseSeats"
      :tickets-types="ticketsTypes"
      @closeAdviseSeats="closeAdviseSeats"
    />
  </div>
</template>

<script>

import clone from 'lodash.clone'
import { SEATSIOCONFIG } from './configConstant.js'
import { purchase } from '@/plugins/mixins/purchase.js'
import { userStatus } from '@/plugins/mixins/userStatus'
import AdviseSeats from '@/components/advise-seats/AdviseSeats.vue'
import NominativesSeatsio from '@/components/nominatives-seatsio/NominativesSeatsio.vue'
import HowManySeats from '@/components/seatsio/HowManySeats.vue'
import Loader from '@/components/loader/Loader.vue'

export default {
  components: {
    AdviseSeats,
    NominativesSeatsio,
    HowManySeats,
    Loader
  },
  mixins: [purchase, userStatus],
  props: {
    title: {
      type: Boolean,
      default: true
    },
    iframe: {
      type: Object,
      default: () => {}
    },
    singlesSelected: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selectedSeats: [],
      chart: {},
      showButton: false,
      openSeatsioNominatives: false,
      loading: false,
      openHowManySeats: false,
      showAdviseSeats: false,
    }
  },
  computed: {
    event() {
      return this.$store.state.event.detail
    },
    ticketsTypes() {
      const selectTypes = {};
      this.selectedSeats.forEach(item => {
        if(selectTypes[item.category]) {
          selectTypes[item.category] += 1
        } else {
          selectTypes[item.category] = 1
        }
      });
      return this.$store.state.seatsio.tickets.ticket_types.filter(item => !!selectTypes[item.external_id])
    },
    promoter_terms: {
      get() {
        return this.$store.state.purchase.promoter_terms
      },
      set(value) {
        this.$store.dispatch('purchase/setPromoterTerms', value)
      }
    },
    promoter_newsletter: {
      get() {
        return this.$store.state.purchase.promoter_newsletter
      },
      set(value) {
        this.$store.dispatch('purchase/setPromoterNewsletter', value)
      }
    }
  },
  created() {
    this._getConfig()
    this._getTickets()
    this.$root.$on('closeSeatsioNominatives', () => {
      this.openSeatsioNominatives = false
    })
    this.$root.$on('purchaseLoading', status => {
      this.loading = status
    })
  },
  methods: {
    howManySeats(quantity) {
      this.openHowManySeats = false
      this._bestAvailable(quantity)
    },
    validateMinTickets() {
      const selectTypes = {};
      this.selectedSeats.forEach(item => {
        if(selectTypes[item.category]) {
          selectTypes[item.category] += 1
        } else {
          selectTypes[item.category] = 1
        }
      });
      const keys = Object.keys(selectTypes);
      for(const key of keys) {
        if(selectTypes[key] < this.$store.state.seatsio.minTickets[key]) {
          return false
        }
      }
      return true;
    },
    validateAvailable() {
      const selectTypes = {};
      this.selectedSeats.forEach(item => {
        if(selectTypes[item.category]) {
          selectTypes[item.category] += 1
        } else {
          selectTypes[item.category] = 1
        }
      });
      const keys = Object.keys(selectTypes);
      for(const key of keys) {
        if(selectTypes[key] > this.$store.state.seatsio.available[key]) {
          return false
        }
      }
      return true;
    },
    validatePair() {
      const selectTypes = {};
      this.selectedSeats.forEach(item => {
        if(selectTypes[item.category]) {
          selectTypes[item.category] += 1
        } else {
          selectTypes[item.category] = 1
        }
      });
      const keys = Object.keys(selectTypes);
      for(const key of keys) {
        if(this.$store.state.seatsio.pair[key] && selectTypes[key] % 2 !== 0) {
          return false
        }
      }
      return true;
    },
    closeAdviseSeats() {
      this.showAdviseSeats = false
    },
    async manage() {
      if(!this.validateMinTickets()) {
        this.showAdviseSeats = true
        return;
      }
      if(!this.validateAvailable()) {
        this.showAdviseSeats = true
        return;
      }
      if(!this.validatePair()) {
        this.showAdviseSeats = true
        return;
      }

      this.$store.dispatch('seatsio/setData', {
        hold_token: this.$store.state.seatsio.config.hold_token,
        ticket_dist: this.$store.state.event.detail.ticket_distributions[0].id,
        tickets: clone(this.selectedSeats)
      })
      if (this._nominatives()) {
        this.loading = false
        this.openSeatsioNominatives = true
      } else {
        this.$store.dispatch('seatsio/cleanCategoryLabel')
        this.$store.dispatch(
          'purchase/setTickets',
          this.$store.state.seatsio.data
        )
        if (
          this.$store.state.initial.detail.user_id ||
          this.$store.state.user.detail.id
        ) {
          var userStatus = await this.checkUserStatus()
          if (userStatus === 'name' || userStatus === 'profile') {
            this.loading = false
            this.$root.$emit('openBasicInfoPurchase')
          } else {
            this.$store.dispatch('seatsio/cleanCategoryLabel')
            this.$store.dispatch(
              'purchase/setTickets',
              this.$store.state.seatsio.data
            )
            this.loading = true
            this.createPurchase('seatsio')
          }
        } else {
          this.$root.$emit('openSignupPurchase')
        }
      }
    },
    clearSelection() {
      this.chart.clearSelection(() => {
        this.selectedSeats = []
      })
    },
    _bestAvailable(quantity) {
      if (quantity && parseInt(quantity) > 0) {
        let bestAvailableSeats = {
          category: this.$store.state.seatsio.config.select_best_available
            .category,
          number: parseInt(quantity)
        }
        if (typeof this.chart.selectBestAvailable === 'function')
          this.chart.selectBestAvailable(bestAvailableSeats)
      }
    },
    async _getTickets() {
      await this.$store.dispatch('seatsio/tickets', {
        is_streaming: false,
        event: this.$store.state.event.detail.id,
        places: this.singlesSelected > 0 ? this.singlesSelected : undefined
      })
    },
    async _getConfig() {
      console.log('_getConfig', this.$store.state.event);
      await this.$store.dispatch('seatsio/config', {
        ticket_dist: this.$store.state.event.detail.ticket_distributions[0].id,
        places: this.singlesSelected > 0 ? this.singlesSelected : undefined
      })
      this._getScript()
    },
    _getScript() {
      if (typeof this.$loadScript === 'function')
        this.$loadScript(this.$store.state.seatsio.config.widget)
          .then(() => {
            this._createIframe()
          }).catch(res => {
          })
    },
    _createIframe() {
      let config = this.$store.state.seatsio.config
      let seatsioConfig = Object.assign({}, SEATSIOCONFIG, {
        divId: 'container-seatsio-widget',
        publicKey: config.public_key,
        event: this.$store.state.event.detail.ticket_distributions[0]
          .external_id,
        language: config.language,
        holdToken: config.hold_token.hold_token,
        showLegend: config.show_legend,
        selectionValidators: config.selection_validators,
        pricing: config.pricing,
        priceFormatter: price => {
          return this.$n(price, { key: 'currency', currency: config.currency })
        },
        onObjectSelected: object => {
          this._objectSelected(object)
          this._refreshButton(true)
        },
        onObjectDeselected: object => {
          this._objectDeselected(object)
          this._refreshButton(this.selectedSeats.length > 0)
        }
      })
      if (config.numberofplacestoselect) {
        seatsioConfig.numberOfPlacesToSelect = parseInt(config.numberofplacestoselect)
      } else {
        seatsioConfig.maxSelectedObjects = config.max_selected_objects
      }
      this.chart = new window.seatsio.SeatingChart(seatsioConfig).render()
    },
    _nominatives() {
      var isNominative = this.$store.state.seatsio.data.tickets.some(
        ticketSelected => {
          return this.$store.state.seatsio.tickets.ticket_types.some(ticket => {
            return (
              parseInt(ticketSelected.category) ===
                parseInt(ticket.external_id) &&
              (ticket.personal || ticket.personal_id)
            )
          })
        }
      )
      return isNominative
    },
    _objectSelected(object) {
      var seat = {
        external_id: object.id,
        labels: object.labels,
        category: object.category.key,
        category_label: object.category.label
      }
      this.selectedSeats.push(seat)
    },
    _objectDeselected(object) {
      this.selectedSeats = this.selectedSeats.filter((item, index) => {
        return item.external_id !== object.id
      })
    },
    _refreshButton(value) {
      this.showButton = value
    }
  }
}
</script>
<style lang="scss">
@import './seatsio.sass';
</style>
